import { render, staticRenderFns } from "./order.vue?vue&type=template&id=755df366"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('755df366')) {
      api.createRecord('755df366', component.options)
    } else {
      api.reload('755df366', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=755df366", function () {
      api.rerender('755df366', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/order.vue"
export default component.exports